import React from 'react';
import { Link } from 'react-router-dom';
import { all_routes } from '../../router/all_routes';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

const AdminSettings = () => {
  const routes = all_routes;

  return (
    <div className="page-wrapper">
      <div className="content">
        {/* Page Header */}
        <div className="d-md-flex d-block align-items-center justify-content-between border-bottom pb-3">
          <div className="my-auto mb-2">
            <h3 className="page-title mb-1">Admin Settings</h3>
            <nav>
              <ol className="breadcrumb mb-0">
                <li className="breadcrumb-item">
                  <Link to={routes.adminDashboard}>Dashboard</Link>
                </li>
                <li className="breadcrumb-item">
                  <Link to="#">Admin</Link>
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  Admin Settings
                </li>
              </ol>
            </nav>
          </div>
          <div className="d-flex my-xl-auto right-content align-items-center flex-wrap">
            <div className="pe-1 mb-2">
              <OverlayTrigger
                placement="top"
                overlay={<Tooltip id="tooltip-top">Refresh</Tooltip>}
              >
                <Link
                  to="#"
                  className="btn btn-outline-light bg-white btn-icon me-1"
                >
                  <i className="ti ti-refresh" />
                </Link>
              </OverlayTrigger>
            </div>
            <div className="pe-1 mb-2">
              <button className="btn btn-primary">
                <i className="ti ti-device-floppy me-2"></i>
                Save Changes
              </button>
            </div>
          </div>
        </div>

        <div className="row">
          {/* School Information */}
          <div className="col-xl-6">
            <div className="card">
              <div className="card-header">
                <h4 className="card-title">School Information</h4>
              </div>
              <div className="card-body">
                <div className="mb-3">
                  <label className="form-label">School Name <span className="text-danger">*</span></label>
                  <input
                    type="text"
                    className="form-control"
                    defaultValue="Greenwood High School"
                    placeholder="Enter school name"
                  />
                </div>
                <div className="mb-3">
                  <label className="form-label">School Code</label>
                  <input
                    type="text"
                    className="form-control"
                    defaultValue="GHS001"
                    placeholder="Enter school code"
                  />
                </div>
                <div className="mb-3">
                  <label className="form-label">Address</label>
                  <textarea
                    className="form-control"
                    rows={3}
                    defaultValue="123 Education Street, Knowledge City, KN 12345"
                    placeholder="Enter complete address"
                  />
                </div>
                <div className="row">
                  <div className="col-md-6 mb-3">
                    <label className="form-label">Phone Number</label>
                    <input
                      type="tel"
                      className="form-control"
                      defaultValue="+1 (555) 123-4567"
                      placeholder="Enter phone number"
                    />
                  </div>
                  <div className="col-md-6 mb-3">
                    <label className="form-label">Email</label>
                    <input
                      type="email"
                      className="form-control"
                      defaultValue="info@greenwoodhigh.edu"
                      placeholder="Enter email address"
                    />
                  </div>
                </div>
                <div className="mb-3">
                  <label className="form-label">Website</label>
                  <input
                    type="url"
                    className="form-control"
                    defaultValue="https://www.greenwoodhigh.edu"
                    placeholder="Enter website URL"
                  />
                </div>
                {/* TODO: Add logo upload functionality */}
              </div>
            </div>
          </div>

          {/* Academic Settings */}
          <div className="col-xl-6">
            <div className="card">
              <div className="card-header">
                <h4 className="card-title">Academic Configuration</h4>
              </div>
              <div className="card-body">
                <div className="mb-3">
                  <label className="form-label">Academic Year</label>
                  <select className="form-select">
                    <option>2023-2024</option>
                    <option selected>2024-2025</option>
                    <option>2025-2026</option>
                  </select>
                </div>
                <div className="mb-3">
                  <label className="form-label">Grading System</label>
                  <select className="form-select">
                    <option selected>A-F Letter Grades</option>
                    <option>Percentage (0-100)</option>
                    <option>GPA Scale (0-4.0)</option>
                    <option>Pass/Fail</option>
                  </select>
                </div>
                <div className="row">
                  <div className="col-md-6 mb-3">
                    <label className="form-label">Passing Grade</label>
                    <input
                      type="number"
                      className="form-control"
                      defaultValue="60"
                      placeholder="Enter minimum passing grade"
                    />
                  </div>
                  <div className="col-md-6 mb-3">
                    <label className="form-label">Maximum Absences</label>
                    <input
                      type="number"
                      className="form-control"
                      defaultValue="10"
                      placeholder="Per semester"
                    />
                  </div>
                </div>
                <div className="mb-3">
                  <label className="form-label">Class Duration (minutes)</label>
                  <input
                    type="number"
                    className="form-control"
                    defaultValue="45"
                    placeholder="Enter default class duration"
                  />
                </div>
                <div className="mb-3">
                  <label className="form-label">Terms/Semesters</label>
                  <select className="form-select">
                    <option>2 Semesters</option>
                    <option selected>3 Trimesters</option>
                    <option>4 Quarters</option>
                  </select>
                </div>
              </div>
            </div>
          </div>

          {/* System Permissions */}
          <div className="col-xl-6">
            <div className="card">
              <div className="card-header">
                <h4 className="card-title">System Permissions</h4>
              </div>
              <div className="card-body">
                <div className="permission-settings">
                  {/* User Registration */}
                  <div className="d-flex justify-content-between align-items-center flex-wrap border-bottom mb-3">
                    <div className="mb-3">
                      <h6>Allow User Registration</h6>
                      <p className="text-muted">Enable new users to register without admin approval</p>
                    </div>
                    <div className="mb-3">
                      <div className="form-check form-switch">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          id="userRegistration"
                        />
                      </div>
                    </div>
                  </div>

                  {/* Document Requests */}
                  <div className="d-flex justify-content-between align-items-center flex-wrap border-bottom mb-3">
                    <div className="mb-3">
                      <h6>Auto-approve Document Requests</h6>
                      <p className="text-muted">Automatically approve certain document types</p>
                    </div>
                    <div className="mb-3">
                      <div className="form-check form-switch">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          id="autoApprove"
                        />
                      </div>
                    </div>
                  </div>

                  {/* Grade Modifications */}
                  <div className="d-flex justify-content-between align-items-center flex-wrap border-bottom mb-3">
                    <div className="mb-3">
                      <h6>Allow Grade Modifications</h6>
                      <p className="text-muted">Teachers can modify grades after submission</p>
                    </div>
                    <div className="mb-3">
                      <div className="form-check form-switch">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          id="gradeModifications"
                          defaultChecked
                        />
                      </div>
                    </div>
                  </div>

                  {/* Bulk Operations */}
                  <div className="d-flex justify-content-between align-items-center flex-wrap mb-0">
                    <div className="mb-3">
                      <h6>Enable Bulk Operations</h6>
                      <p className="text-muted">Allow bulk user management and data imports</p>
                    </div>
                    <div className="mb-3">
                      <div className="form-check form-switch">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          id="bulkOperations"
                          defaultChecked
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Security Settings */}
          <div className="col-xl-6">
            <div className="card">
              <div className="card-header">
                <h4 className="card-title">Security & Access</h4>
              </div>
              <div className="card-body">
                <div className="mb-3">
                  <label className="form-label">Session Timeout (minutes)</label>
                  <select className="form-select">
                    <option>15 minutes</option>
                    <option selected>30 minutes</option>
                    <option>60 minutes</option>
                    <option>120 minutes</option>
                    <option>No timeout</option>
                  </select>
                </div>
                
                <div className="mb-3">
                  <label className="form-label">Password Policy</label>
                  <select className="form-select">
                    <option>Basic (6+ characters)</option>
                    <option selected>Standard (8+ chars, mixed case)</option>
                    <option>Strong (12+ chars, special chars)</option>
                    <option>Custom</option>
                  </select>
                </div>

                <div className="mb-3">
                  <label className="form-label">Failed Login Attempts</label>
                  <select className="form-select">
                    <option>3 attempts</option>
                    <option selected>5 attempts</option>
                    <option>10 attempts</option>
                    <option>Unlimited</option>
                  </select>
                </div>

                <div className="security-options">
                  <div className="form-check mb-2">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      id="twoFactor"
                      defaultChecked
                    />
                    <label className="form-check-label" htmlFor="twoFactor">
                      Enable Two-Factor Authentication
                    </label>
                  </div>
                  
                  <div className="form-check mb-2">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      id="ipRestriction"
                    />
                    <label className="form-check-label" htmlFor="ipRestriction">
                      IP Address Restrictions
                    </label>
                  </div>

                  <div className="form-check mb-2">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      id="auditLog"
                      defaultChecked
                    />
                    <label className="form-check-label" htmlFor="auditLog">
                      Enable Audit Logging
                    </label>
                  </div>
                </div>
                {/* TODO: Implement IP whitelist functionality */}
                {/* TODO: Add audit log viewer */}
              </div>
            </div>
          </div>

          {/* Backup & Maintenance */}
          <div className="col-xl-6">
            <div className="card">
              <div className="card-header">
                <h4 className="card-title">Backup & Maintenance</h4>
              </div>
              <div className="card-body">
                <div className="mb-3">
                  <label className="form-label">Automatic Backup Schedule</label>
                  <select className="form-select">
                    <option>Disabled</option>
                    <option selected>Daily at 2:00 AM</option>
                    <option>Weekly on Sunday</option>
                    <option>Monthly</option>
                  </select>
                </div>

                <div className="mb-3">
                  <label className="form-label">Backup Retention</label>
                  <select className="form-select">
                    <option>7 days</option>
                    <option selected>30 days</option>
                    <option>90 days</option>
                    <option>1 year</option>
                  </select>
                </div>

                <div className="mb-3">
                  <h6>Maintenance Window</h6>
                  <div className="row">
                    <div className="col-6">
                      <label className="form-label">Start Time</label>
                      <input type="time" className="form-control" defaultValue="01:00" />
                    </div>
                    <div className="col-6">
                      <label className="form-label">End Time</label>
                      <input type="time" className="form-control" defaultValue="05:00" />
                    </div>
                  </div>
                </div>

                <div className="d-grid gap-2">
                  <button className="btn btn-warning">
                    <i className="ti ti-database-backup me-2"></i>
                    Create Manual Backup
                  </button>
                  <button className="btn btn-info">
                    <i className="ti ti-download me-2"></i>
                    Download Latest Backup
                  </button>
                </div>
                {/* TODO: Implement backup creation and download functionality */}
              </div>
            </div>
          </div>

          {/* System Information */}
          <div className="col-xl-6">
            <div className="card">
              <div className="card-header">
                <h4 className="card-title">System Information</h4>
              </div>
              <div className="card-body">
                <div className="system-info">
                  <div className="d-flex justify-content-between border-bottom pb-2 mb-2">
                    <span>System Version:</span>
                    <span className="fw-semibold">v2.4.1</span>
                  </div>
                  <div className="d-flex justify-content-between border-bottom pb-2 mb-2">
                    <span>Database Version:</span>
                    <span className="fw-semibold">MySQL 8.0.33</span>
                  </div>
                  <div className="d-flex justify-content-between border-bottom pb-2 mb-2">
                    <span>Last Backup:</span>
                    <span className="fw-semibold text-success">Today 02:00 AM</span>
                  </div>
                  <div className="d-flex justify-content-between border-bottom pb-2 mb-2">
                    <span>Server Uptime:</span>
                    <span className="fw-semibold">15 days, 8 hours</span>
                  </div>
                  <div className="d-flex justify-content-between border-bottom pb-2 mb-2">
                    <span>Storage Used:</span>
                    <span className="fw-semibold">2.3 GB / 50 GB</span>
                  </div>
                  <div className="d-flex justify-content-between">
                    <span>Active Users:</span>
                    <span className="fw-semibold text-primary">1,247</span>
                  </div>
                </div>

                <div className="mt-3">
                  <button className="btn btn-outline-primary w-100">
                    <i className="ti ti-info-circle me-2"></i>
                    View System Logs
                  </button>
                </div>
                {/* TODO: Link to system logs viewer */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminSettings;
